import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9ikkew92sw: FaireBrandEntity = {
  token: "b_9ikkew92sw",
  type: "brand",
  name: "Giften Market",
  avatarUrl:
    "https://cdn.faire.com/fastly/4b1c4442fe22c618697d7536aebcb7c514a360885481822b10230ccd6e449f36.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a19743f50deb732dba0f37cd88e338ff9ec3ec4b15b5e0580f3253cfd5aa0de2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4b1c4442fe22c618697d7536aebcb7c514a360885481822b10230ccd6e449f36.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a19743f50deb732dba0f37cd88e338ff9ec3ec4b15b5e0580f3253cfd5aa0de2.jpeg",
  location: "Edina, MN, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 39,
  isTopShop: true,
  isInsider: true,
  description:
    "Giften Market produces high-quality, thoughtful gifts designed to delight those with discerning tastes. Each product in our catalog is meticulously handpicked to encapsulate feelings such as warmth, comfort, and positivity. When you gift with Giften Market, you're not just delivering a present, but a tangible expression of your sentiment, a virtual hug that makes the recipient feel cozy, relaxed, and uplifted. \n\nOur mission is to ensure every gift not only meets the standard of quality but also carries a personal touch, making every unboxing experience a cherished moment. Immerse yourself in the art of meaningful gifting with Giften Market - where each gift tells a story.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:05.986Z",
    importedBy: "entity-db-cli",
  },
};
